import { PaymentTermSortField } from "@/graphql/codegen/graphql"

export type PaymentTermSortableAccessorKey = "name" | "CreatedOn"

export const accessorKeyToPaymentTermSortField = new Map<PaymentTermSortableAccessorKey, PaymentTermSortField>([
  ["name", PaymentTermSortField.Name],
  ["CreatedOn", PaymentTermSortField.CreatedOn],
])

export const paymentTermSortFieldToAccessoryKey = new Map<PaymentTermSortField, PaymentTermSortableAccessorKey>([
  [PaymentTermSortField.Name, "name"],
  [PaymentTermSortField.CreatedOn, "CreatedOn"],
])
